export default {
  ROJOU_DOBOKU: 1,
  ROJOU_SHISETSU_DENKI: 2,
  ROKA_DOBOKU: 3,
  ROKA_SHISETSU_DENKI: 4,
  KOUKASHITA_KOUKASHITA: 5,
}
